import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from "@angular/router";
import {Observable} from "rxjs";
import {map, tap} from "rxjs/operators";
import {AuthUserService} from "../../@shared/services/auth/auth-user.service";

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(private route: Router, private authUserService: AuthUserService) {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {

    return this.authUserService.user$.pipe(
      map((user) => user !== undefined),
      tap((isLogged: boolean) => {
        if (!isLogged) this.route.navigate(['/login'])
      }),
    )
  }

}


// return of(Boolean(this.authUserService.user.getValue()))//взять токен / сверить / сходить на сервер???
//   .pipe(
//     switchMap((isLogged: boolean) => {
//       if (!isLogged && url === '/login') {
//         return of(true)
//       }
//
//       if (isLogged && url === '/login') {
//         this.route.navigate(['/user'])
//         return of(false)
//       }
//
//       if (!isLogged) {
//         this.route.navigate(['/login'])
//       }
//
//       return of(isLogged)
//     })
//   )
